export default __webpack_public_path__ + "static/form-one-column-do-64797ae0e5b5a40d8ab7e7eee2ebb6416a7ac3a99a14a965373e9f4d873b4145.png";